<template>
  <div>
    <div>
      <input
        type="radio"
        :name="getRadioName()"
        value="option1"
        :id="getID(0)"
        :data-nextPfrpID="count + 1"
        v-model="selectedOption"
      />
      <label :for="getID(0)">Chairman of the Meeting</label>
    </div>
    <div>
      <input
        type="radio"
        :name="getRadioName()"
        value="option2"
        :id="getID(1)"
        :data-nextPfrpID="count + 2"
        v-model="selectedOption"
      />
      <label :for="getID(1)">the following person(s)</label>
    </div>
    <div>
      <input
        type="radio"
        :name="getRadioName()"
        value="option3"
        :id="getID(2)"
        :data-nextPfrpID="count + 3"
        v-model="selectedOption"
      />
      <label :for="getID(2)">the following person(s), with fallback to Chairman</label>
    </div>

    <div v-if="selectedOption == 'option1'" class="proportion">
      <strong v-if="!field.metadata.hideProportionHeader">Proportion of Shareholdings</strong>
      <div class="input-box">
        <input placeholder=" " />
        <div class="input-label">No. of Shares</div>
      </div>
      <div class="input-box">
        <input placeholder=" " />
        <div class="input-label">%</div>
      </div>
    </div>

    <div v-else-if="selectedOption == 'option2' || selectedOption == 'option3'">
      
      <div class="proxyholder">
        <div class="header" @click="toggleDropdown(0)">
          Proxyholder 1
        </div>
        <div class="pfrp-component">
          <div class="input-box">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">Name</div>
          </div>
          <div class="input-box">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">NRIC / Passport Number / Company Regn. No.</div>
          </div>
          <div class="side-label grid-col-1-3">
            <label> of </label>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label" v-if="!field.metadata.hideInlineLabels"> Address </div>
            </div>
          </div>
          <div class="input-box grid-col-1-3">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">Email</div>
          </div>
          <div class="proportion grid-col-1-3">
            <strong v-if="!field.metadata.hideProportionHeader">Proportion of Shareholdings</strong>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label">No. of Shares</div>
            </div>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label">%</div>
            </div>
          </div>
        </div>
      </div>

      <div class="checkboxes">
        <input type="radio" :name="getCheckboxName()" :id="getRadioID(0)">
        <label :for="getRadioID(0)"> AND </label>
        <input type="radio" :name="getCheckboxName()" :id="getRadioID(1)">
        <label :for="getRadioID(1)"> OR </label>
      </div>
      
      <div class="proxyholder">
        <div class="header" @click="toggleDropdown(1)">
          Proxyholder 2
        </div>
        <div class="pfrp-component">
          <div class="input-box">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">Name</div>
          </div>
          <div class="input-box">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">NRIC / Passport Number / Company Regn. No.</div>
          </div>
          <div class="side-label grid-col-1-3">
            <label> of </label>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label" v-if="!field.metadata.hideInlineLabels"> Address </div>
            </div>
          </div>
          <div class="input-box grid-col-1-3">
            <input placeholder=" " />
            <div class="input-label" v-if="!field.metadata.hideInlineLabels">Email</div>
          </div>
          <div class="proportion grid-col-1-3">
            <strong v-if="!field.metadata.hideProportionHeader">Proportion of Shareholdings</strong>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label">No. of Shares</div>
            </div>
            <div class="input-box">
              <input placeholder=" " />
              <div class="input-label">%</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "FormPFRP",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      selectedOption: "",
      count: 0,
    };
  },
  watch: {
    defaultChairman: function() {
      this.setDefaultHolder();
    },
  },
  computed: {
    defaultChairman() {
      return this.field.metadata.defaultChairmanAsIndVal;
    }
  },
  methods: {
    setOption: function (event) {
      this.selectedOption = event.target.value;
    },
    setRadioChecked: function (value) {
      return value === this.selectedOption;
    },
    getID: function (index) {
      const ID_PREFIX = "form-pfrp";
      return `${ID_PREFIX}-${this.count + index}`;
    },
    getRadioID: function (index) {
      const ID_PREFIX = "radio-pfrp";
      return `${ID_PREFIX}-${this.count + index}`;
    },
    getRadioName: function () {
      const ID_PREFIX = "radio-pfrp";
      return `${ID_PREFIX}-${this.count}`;
    },
    getCheckboxName: function () {
      const ID_PREFIX = "checkbox-pfrp";
      return `${ID_PREFIX}-${this.count}`;
    },
    toggleDropdown: function (index) {
      const body = this.$el.querySelectorAll(".pfrp-component")[index];
      body.classList.toggle("hidden")
    },
    setDefaultHolder: function () {
      this.selectedOption = "option" + this.field.metadata.defaultChairmanAsIndVal;
    }
  },
  beforeMount() {
    const checkboxes = document.querySelectorAll("input[data-nextPfrpID]");
    if (checkboxes.length <= 0) {
      this.count = 1;
    } else {
      this.count = parseInt(
        checkboxes[checkboxes.length - 1].dataset.nextpfrpid
      );
    }
  },
  mounted() {
    this.setDefaultHolder();
  },
};
</script>

<style scoped>
.side-label {
  display: flex;
  align-items: center;
}

.side-label > label {
  margin-right: 0.5rem;
}

.input-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
  margin: 0.5rem 0;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.proportion {
  margin-top: 0.5rem;
}

.proxyholder {
  border: 1px solid #ddd;
  border-radius: 0.25rem 0.25rem 0 0;
  margin-top: 0.5rem;
}

.header {
  background: #eee;
  border: 1px solid #ddd;
  border-radius: 0.25rem 0.25rem 0 0;
  min-height: 56px;
  padding: 8px 16px;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.pfrp-component {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: 0.5rem;
  padding: 1rem;
  max-height: 600px;
  transition: max-height 0.25s linear;
}

.checkboxes {
  display: flex;
  align-items: center;
  margin: 1rem 0 0.5rem 0;
}

.checkboxes > label {
  margin-right: 0.5rem;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.hidden {
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  max-height: 0;
  padding: 0;
}

.required {
  color: #f00;
}
</style>